module.exports = __webpack_public_path__ + "img/active-registered.307db07d.png";